// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cebd4a59","369":"c9e7db02","455":"9eea6b38","517":"24e81b67","588":"b99850d0","602":"0e0b7c6f","643":"bbdd4ab6","644":"86de32f1","865":"17f6d0f3","878":"bbdb7dae","937":"3ee3180f"}[chunkId] + ".chunk.js";
};